import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import GoogleLoginButton from '../components/GoogleLoginButton';

class CheckSession extends Component {
    constructor() {
        super();
        this.state = {
          error_google_login: null,
        }
      }
    render() {
        const {error_google_login} = this.state;
        const {UI: {expLogin}, history} = this.props;
        return (
            <Fragment>
                <div className={`overlay-to-right ${expLogin ? 'show' : ''}`} />
                {expLogin &&
                <div className="center text-center" style={{zIndex: 102}}>
                     <p>{error_google_login ? error_google_login.message : expLogin}</p>
                     <GoogleLoginButton history={history} setProfile={(profile) => this.setState({profile})} setErrorLogin={(error_google_login) => this.setState({error_google_login})} />
                </div>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    UI: state.UI,
})

export default connect(mapStateToProps, null)(CheckSession);
